import { useBackgroundFilters } from '@stream-io/video-react-sdk';
import {
  DropdownMenu,
  DropdownMenuItem,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Button } from '@/components/ui/button';
import { ChevronUp } from 'lucide-react';

export const BackgroundFilterSettings = () => {
  const { isSupported, isReady, disableBackgroundFilter, applyBackgroundBlurFilter } =
    useBackgroundFilters();

  if (!isSupported) {
    return <></>;
  }

  if (!isReady) {
    return <div className="my-loading-indicator" />;
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="outline"
          className="rounded-full h-9 pl-3 pr-2 bg-[#19232d] hover:bg-[#323b44] text-[#eff0f1] hover:text-[#eff0f1] border-none ring-0 flex items-center space-x-2"
        >
          <p>Blur</p>
          <div className="w-4 h-4">
            <ChevronUp className="w-4 h-4" />
          </div>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="center"
        side="top"
        className="bg-[#19232d] text-[#eff0f1] z-99999999 border-slate-400"
      >
        <DropdownMenuItem onClick={disableBackgroundFilter}>Disable</DropdownMenuItem>
        <DropdownMenuItem onClick={() => applyBackgroundBlurFilter('low')}>
          Low Blur
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => applyBackgroundBlurFilter('medium')}>
          Medium Blur
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => applyBackgroundBlurFilter('high')}>
          High Blur
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
